import { c as _c } from "react/compiler-runtime";
import { AllTreatmentCard } from "@/widgets/treatment-case/ui/molecules";
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
interface AllTreatmentListProps {
  contentList: {
    categoryId: number;
    categoryName: string;
    description: string;
    summaryList: TreatmentCaseSummaryResponse[];
  }[];
}
const AllTreatmentList = t0 => {
  const $ = _c(4);
  const {
    contentList
  } = t0;
  let t1;
  if ($[0] !== contentList) {
    t1 = contentList.map(_temp);
    $[0] = contentList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="bg-gray-100">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default AllTreatmentList;
function _temp(content, index) {
  return <AllTreatmentCard key={`all-treatment-card-${index}`} content={content} />;
}